import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Field, ErrorMessage } from "formik";
import TextareaAutosize from "react-textarea-autosize";
import * as Yup from "yup";

import Localization from "../../../../localization";
import Button from "../../../../components/button";

class Step7Form extends Component {
    constructor(props) {
        super(props);

        this.myRef = React.createRef();
        this._onChange = this._onChange.bind(this);
    }

    componentDidMount() {
        this.props.myRef(this.myRef);
    }

    _onChange(selected) {
        this.myRef.current.setFieldValue("has_more_financing", selected);
    }

    render() {
        const { locale, values } = this.props;

        const registSchema = Yup.object().shape({
            biography: Yup.string().required(
                Localization[locale].validation.required
            ),
            has_more_financing: Yup.string().required(
                Localization[locale].validation.required
            ),
        });

        const initialValues = {
            biography: (values && values.biography) || "",
            has_more_financing: (values && values.has_more_financing) || "0",
            financing: (values && values.financing) || "",
            video_links: (values && values.video_links) || "",
        };

        const textSelected =
            "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white";
        const textUnselected =
            "font-bold text-17 z-10 transition hover-hover:group-hover:text-white hover-hover:group-hover:opacity-100 text-black opacity-20";

        const bgSelected = "bg-blue";
        const bgUnselected = "bg-grey";

        const borderSelected = "border-blue";
        const borderUnselected = "border-black border-opacity-20";

        return (
            <Formik
                initialValues={initialValues}
                validationSchema={registSchema}
                innerRef={this.myRef}
                onSubmit={(values) => {}}
            >
                {({ handleSubmit, values, handleChange }) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <TextareaAutosize
                                value={values.biography}
                                cacheMeasurements
                                type="text"
                                name="biography"
                                maxLength={8000}
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full font-brown"
                                placeholder={
                                    Localization[locale].artistic_booking
                                        .step_7_bio_placeholder
                                }
                                onChange={handleChange}
                            />
                            <p className="text-orange text-12 mt-6">
                                {
                                    Localization[locale].artistic_booking
                                        .step_7_bio_max
                                }
                            </p>
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="biography" />
                            </p>
                        </div>
                        <p className="font-bold text-20 text-blue mt-26">
                            {
                                Localization[locale].artistic_booking
                                    .step_7_financing_title
                            }
                        </p>
                        <div className="flex flex-col xl:flex-row flex-wrap mt-26 xl:-mx-8">
                            <Button
                                text={
                                    Localization[locale].artistic_booking
                                        .step_7_financing_op_1
                                }
                                textStyle={
                                    values.has_more_financing === "1"
                                        ? textSelected
                                        : textUnselected
                                }
                                backgroundColor={
                                    values.has_more_financing === "1"
                                        ? bgSelected
                                        : bgUnselected
                                }
                                borderColor={
                                    values.has_more_financing === "1"
                                        ? borderSelected
                                        : borderUnselected
                                }
                                style={"mb-8 xl:m-8"}
								wrapperStyle="px-20"
                                onClick={() => {
                                    this._onChange("1");
                                }}
                            />
                            <Button
                                text={
                                    Localization[locale].artistic_booking
                                        .step_7_financing_op_2
                                }
                                textStyle={
                                    values.has_more_financing === "0"
                                        ? textSelected
                                        : textUnselected
                                }
                                backgroundColor={
                                    values.has_more_financing === "0"
                                        ? bgSelected
                                        : bgUnselected
                                }
                                borderColor={
                                    values.has_more_financing === "0"
                                        ? borderSelected
                                        : borderUnselected
                                }
                                style={"mb-8 xl:m-8"}
								wrapperStyle="px-20"
                                onClick={() => {
                                    this._onChange("0");
                                }}
                            />
                        </div>
                        {values.has_more_financing === "1" && (
                            <div className="mt-26">
                                <Field
                                    type="text"
                                    name="financing"
                                    className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    placeholder={
                                        Localization[locale].artistic_booking
                                            .step_7_financing_op_3
                                    }
                                />
                                <p className="text-red text-12 mt-6">
                                    <ErrorMessage name="financing" />
                                </p>
                            </div>
                        )}
                        <p className="font-bold text-20 text-blue mt-26">
                            {
                                Localization[locale].artistic_booking
                                    .step_7_video_links_title
                            }
                        </p>
                        <div className="mt-26">
                            <TextareaAutosize
                                value={values.video_links}
                                cacheMeasurements
                                type="text"
                                name="video_links"
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full font-brown"
                                placeholder={
                                    Localization[locale].artistic_booking
                                        .step_7_video_links_placeholder
                                }
                                onChange={handleChange}
                            />
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="video_links" />
                            </p>
                        </div>
                    </form>
                )}
            </Formik>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Step7Form);
